import { ChangeDetectionStrategy, Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { OptionTypeService } from 'app/modules/option-type/services/option-type.service';
import module from 'app/modules/option-type/option-type.module';

@Component({
  selector: 'app-edit-option-type',
  templateUrl: './edit-option-type.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: module,
  styleUrls: ['./edit-option-type.component.scss']
})
export class EditOptionTypeComponent {
  public optionTypeBody = { 
    id: '',
    name : '',
    description : '',
  }

  public isLoading: boolean = false
  public isSuccess: boolean = false


  constructor(
    public dialogRef: MatDialogRef<EditOptionTypeComponent>,
    @Inject(MAT_DIALOG_DATA) public optionTypeData: any,
    public dialog: MatDialog,
    private metadataService: OptionTypeService) {
      this.optionTypeBody = {
        id: optionTypeData.id,
        name: optionTypeData.name,
        description: optionTypeData.description
      }
     }

  updateCategoryDetails() {
    this.isLoading = true
    
    this.metadataService.updateOption(this.optionTypeBody.id,this.optionTypeBody).subscribe((res)=> {
      this.isLoading = false
      this.isSuccess = true
      this.closeDialog()
    }) 
  }

  closeDialog(): void {
    this.dialogRef.close(this.isSuccess);
  }
}
